import { type PropsWithChildren } from 'react';

export function Container({ children }: PropsWithChildren) {
  return (
    <div className='p-8 sm:ml-80 h-screen dark:bg-slate-950'>{children}</div>
  );
}
